(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3023],{

/***/ 57947:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/used-cars/[make]/[model]/[slug]",
      function () {
        return __webpack_require__(86316);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ CarReviewsV2Feature; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 264 modules
var src = __webpack_require__(60620);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var storyblok_src = __webpack_require__(60782);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/assets/star-no-fill.tsx

const StarNoFill = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "empty-star",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 18.3507L17.4258 21.2214L16.3888 15.139L20.7908 10.8212L14.7092 9.93179L12 4.40688L9.29076 9.93179L3.20914 10.8212L7.61115 15.139L6.57422 21.2214L12 18.3507ZM6.00062 15.6604L4.92494 21.9701C4.78553 22.7879 5.64511 23.41 6.37839 23.022L12 20.0477L17.6216 23.022C18.3549 23.41 19.2144 22.7879 19.075 21.9701L17.9994 15.6604L22.5608 11.1863C23.1512 10.6072 22.8235 9.60257 22.0053 9.4829L15.7081 8.56193L12.8978 2.83096C12.5319 2.08467 11.4681 2.08467 11.1021 2.83096L8.29186 8.56193L1.99471 9.4829C1.17645 9.60257 0.848808 10.6072 1.43919 11.1863L6.00062 15.6604Z",
            fill: "#5234B6"
        })
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/assets/star-fill.tsx

const StarFill = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "filled-star",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12 20.0477L6.37839 23.022C5.64511 23.41 4.78553 22.7879 4.92494 21.9701L6.00062 15.6604L1.43919 11.1863C0.848808 10.6072 1.17645 9.60257 1.99471 9.4829L8.29186 8.56193L11.1021 2.83096C11.4681 2.08467 12.5319 2.08467 12.8978 2.83096L15.7081 8.56193L22.0053 9.4829C22.8235 9.60257 23.1512 10.6072 22.5608 11.1863L17.9994 15.6604L19.075 21.9701C19.2144 22.7879 18.3549 23.41 17.6216 23.022L12 20.0477Z",
            fill: "#5234B6"
        })
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/assets/star-half-fill.tsx

const StarHalfFill = ({ idPrefix  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "half-filled-star",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 18.3507L17.4258 21.2214L16.3888 15.139L20.7908 10.8212L14.7092 9.93179L12 4.40688L9.29076 9.93179L3.20914 10.8212L7.61115 15.139L6.57422 21.2214L12 18.3507ZM6.00062 15.6604L4.92494 21.9701C4.78553 22.7879 5.64511 23.41 6.37839 23.022L12 20.0477L17.6216 23.022C18.3549 23.41 19.2144 22.7879 19.075 21.9701L17.9994 15.6604L22.5608 11.1863C23.1512 10.6072 22.8235 9.60257 22.0053 9.4829L15.7081 8.56193L12.8978 2.83096C12.5319 2.08467 11.4681 2.08467 11.1021 2.83096L8.29186 8.56193L1.99471 9.4829C1.17645 9.60257 0.848808 10.6072 1.43919 11.1863L6.00062 15.6604Z",
                fill: "#5234B6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: `${idPrefix}-half-fill-mask`,
                x: "0",
                y: "0",
                width: "12",
                height: "24",
                fill: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "0",
                    width: "12",
                    height: "24"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 18.3507L17.4258 21.2214L16.3888 15.139L20.7908 10.8212L14.7092 9.93179L12 4.40688L9.29076 9.93179L3.20914 10.8212L7.61115 15.139L6.57422 21.2214L12 18.3507ZM6.00062 15.6604L4.92494 21.9701C4.78553 22.7879 5.64511 23.41 6.37839 23.022L12 20.0477L17.6216 23.022C18.3549 23.41 19.2144 22.7879 19.075 21.9701L17.9994 15.6604L22.5608 11.1863C23.1512 10.6072 22.8235 9.60257 22.0053 9.4829L15.7081 8.56193L12.8978 2.83096C12.5319 2.08467 11.4681 2.08467 11.1021 2.83096L8.29186 8.56193L1.99471 9.4829C1.17645 9.60257 0.848808 10.6072 1.43919 11.1863L6.00062 15.6604Z",
                fill: "#5234B6",
                mask: `url(#${idPrefix}-half-fill-mask)`
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/assets/cross-icon.tsx

const CrossIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_2537_8417)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0.704505 21.7046C0.265165 22.144 0.265165 22.8563 0.704505 23.2956C1.14384 23.735 1.85616 23.735 2.2955 23.2956L12 13.5911L21.7045 23.2957C22.1439 23.735 22.8562 23.735 23.2955 23.2957C23.7349 22.8563 23.7349 22.144 23.2955 21.7047L13.591 12.0001L23.2954 2.29568C23.7348 1.85634 23.7348 1.14403 23.2954 0.704688C22.8561 0.265348 22.1438 0.265348 21.7044 0.704688L12 10.4091L2.29559 0.704722C1.85625 0.265382 1.14394 0.265382 0.704596 0.704722C0.265257 1.14406 0.265257 1.85637 0.704596 2.29571L10.409 12.0001L0.704505 21.7046Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2537_8417",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/assets/tick-with-circle.tsx

const TickWithCircle = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1122_9148)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C12.7512 1.5 13.4831 1.57876 14.1883 1.7282C14.5935 1.81407 14.9916 1.55519 15.0775 1.14997C15.1633 0.744759 14.9044 0.346655 14.4992 0.260783C13.6924 0.0898084 12.8563 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 11.6637 23.9861 11.3304 23.959 11.0008C23.9249 10.588 23.5626 10.281 23.1498 10.315C22.737 10.3491 22.43 10.7114 22.464 11.1242C22.4878 11.4128 22.5 11.7049 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.5394 4.02106C23.8272 3.72313 23.819 3.24833 23.5211 2.96056C23.2231 2.67278 22.7483 2.68102 22.4606 2.97895L11.3961 14.4339L6.52658 9.63261C6.23163 9.34179 5.75676 9.34514 5.46594 9.64009C5.17512 9.93504 5.17847 10.4099 5.47342 10.7007L10.8825 16.0341C11.0251 16.1747 11.218 16.2524 11.4182 16.2499C11.6185 16.2475 11.8094 16.1651 11.9485 16.0211L23.5394 4.02106Z",
                        fill: "currentColor"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1122_9148",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/assets/index.ts






// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/star-rating/star-rating.module.css
var star_rating_module = __webpack_require__(37590);
var star_rating_module_default = /*#__PURE__*/__webpack_require__.n(star_rating_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/star-rating/star-rating.tsx



const StarRating = ({ starRating  })=>{
    const stars = [
        ...Array.from({
            length: 5
        }).keys()
    ];
    const starComponents = stars.map((_, index)=>{
        const isHalfStar = starRating % 2 !== 0 || Number.isInteger(starRating / 2);
        const starNumber = index + 1;
        const idPrefix = `star-${starRating}-${starNumber}`;
        return starNumber <= starRating / 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StarFill, {}, `starRating-${starNumber}`) : isHalfStar && starNumber === Math.ceil(starRating / 2) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StarHalfFill, {
            idPrefix: idPrefix
        }, `starRating-${starNumber}`) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StarNoFill, {}, `starRating-${starNumber}`);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (star_rating_module_default()).starRatingContainer,
        children: starComponents
    });
};
/* harmony default export */ var star_rating = (StarRating);

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/star-rating/index.ts


// EXTERNAL MODULE: ../../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(19601);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ../../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(12093);
// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/author/author.module.css
var author_module = __webpack_require__(19373);
var author_module_default = /*#__PURE__*/__webpack_require__.n(author_module);
// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var util_src = __webpack_require__(37479);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/author/author.tsx






const imageSchema = lib.z.object({
    filename: lib.z.string(),
    alt: lib.z.string().optional()
});
function Author({ latestPublishDate , name , image  }) {
    const actualImage = imageSchema.safeParse(image);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (author_module_default()).author,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (author_module_default()).border,
                children: actualImage.success ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: actualImage.data.filename,
                    alt: actualImage.data.alt ?? "An Image of the author",
                    width: 210,
                    height: 210,
                    loader: (0,storyblok_src/* generateImageLoader */.D_)({
                        height: 210,
                        widthOverride: 210,
                        useSmartCrop: true
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/images/author-fallback.png",
                    alt: "Cinch logo"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (author_module_default()).textContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "By ",
                        name || "cinch",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (author_module_default()).breakline,
                            "aria-hidden": true,
                            children: "|"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (author_module_default()).updatedOn,
                            children: [
                                "Updated on ",
                                (0,util_src/* getDayMonthYearFormat */.Al)(latestPublishDate)
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var author = ((/* unused pure expression or super */ null && (Author)));

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/author/index.ts


// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/design-system/components/icons/src/index.ts + 266 modules
var icons_src = __webpack_require__(39957);
// EXTERNAL MODULE: ../../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(23939);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/hooks/use-vehicle-gallery/use-vehicle-gallery.hook.tsx

const useVehicleGallery = (0,esm/* create */.Ue)((set)=>{
    return {
        setImageIndex: (index)=>new Promise((res)=>res(set({
                    imageIndex: index
                }))),
        imageIndex: null,
        imageIndexes: null,
        setImageIndexes: (images, sections)=>{
            var ref, ref1, ref2, ref3;
            const interiorSectionImageIndex = images === null || images === void 0 ? void 0 : images.map((image)=>image.id).indexOf((ref = sections.interior.image) === null || ref === void 0 ? void 0 : ref.id);
            const performanceSectionImageIndex = images === null || images === void 0 ? void 0 : images.map((image)=>image.id).indexOf((ref1 = sections.performance.image) === null || ref1 === void 0 ? void 0 : ref1.id);
            const practicalitySectionImageIndex = images === null || images === void 0 ? void 0 : images.map((image)=>image.id).indexOf((ref2 = sections.practicality.image) === null || ref2 === void 0 ? void 0 : ref2.id);
            const runningCostsSectionImageIndex = images === null || images === void 0 ? void 0 : images.map((image)=>image.id).indexOf((ref3 = sections.runningCosts.image) === null || ref3 === void 0 ? void 0 : ref3.id);
            set({
                imageIndexes: {
                    interiorSectionImageIndex,
                    performanceSectionImageIndex,
                    practicalitySectionImageIndex,
                    runningCostsSectionImageIndex
                }
            });
        }
    };
});

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/hooks/use-vehicle-gallery/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/hooks/use-modal/use-modal.ts

const useModal = (0,esm/* create */.Ue)((set)=>({
        isOpen: false,
        returnValue: undefined,
        open: ()=>set({
                isOpen: true
            }),
        close: ()=>set({
                isOpen: false
            }),
        setReturnValue: (returnValue)=>set({
                returnValue
            })
    }));

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/hooks/use-modal/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/hooks/index.ts



// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/media/media.module.css
var media_module = __webpack_require__(56303);
var media_module_default = /*#__PURE__*/__webpack_require__.n(media_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/media/media.tsx






const Media = ({ imageCount , imageSrc , title , alt , video  })=>{
    var ref;
    const { open  } = useModal();
    const { setImageIndex , imageIndexes  } = useVehicleGallery();
    const youtubeVideo = (video === null || video === void 0 ? void 0 : video[0]) ?? {};
    const { videoId , title: videoTitle , buttonLabel , thumbnail  } = youtubeVideo;
    const propsExist = videoId && videoTitle && buttonLabel && (thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.filename);
    const shouldShowImage = youtubeVideo && Object.keys(youtubeVideo).length === 0;
    const getImageIndex = ()=>{
        switch(title){
            case "Interior":
                return (imageIndexes === null || imageIndexes === void 0 ? void 0 : imageIndexes.interiorSectionImageIndex) || 0;
            case "Performance":
                return (imageIndexes === null || imageIndexes === void 0 ? void 0 : imageIndexes.performanceSectionImageIndex) || 0;
            case "Practicality":
                return (imageIndexes === null || imageIndexes === void 0 ? void 0 : imageIndexes.practicalitySectionImageIndex) || 0;
            case "Running costs":
                return (imageIndexes === null || imageIndexes === void 0 ? void 0 : imageIndexes.runningCostsSectionImageIndex) || 0;
            default:
                return 0;
        }
    };
    const handleClick = async ()=>{
        if (title) {
            await setImageIndex(getImageIndex());
        }
        open();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (media_module_default()).mediaContainer,
                children: shouldShowImage && imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,storyblok_src/* getStoryblokImageServiceUrl */.Vb)(imageSrc, {
                                filters: [
                                    {
                                        quality: 80
                                    }
                                ]
                            }),
                            alt: alt,
                            className: (media_module_default()).mediaImage
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (media_module_default()).mediaImageInfo,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.GalleryIcon, {}),
                                "Gallery (",
                                imageCount,
                                ")"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (media_module_default()).videoContainer,
                children: !shouldShowImage && propsExist && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Youtube */.hx, {
                    videoId: videoId,
                    title: videoTitle,
                    buttonLabel: buttonLabel,
                    className: (media_module_default()).video,
                    customThumbnail: (0,storyblok_src/* getStoryblokImageServiceUrl */.Vb)((thumbnail === null || thumbnail === void 0 ? void 0 : (ref = thumbnail.filename) === null || ref === void 0 ? void 0 : ref.length) ? thumbnail.filename : imageSrc, {
                        filters: [
                            {
                                quality: 80
                            }
                        ]
                    }),
                    videoUrlOptions: {
                        autoplay: 1
                    },
                    showNewPlayIcon: true
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/media/index.ts


// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/intro/intro.module.css
var intro_module = __webpack_require__(15145);
var intro_module_default = /*#__PURE__*/__webpack_require__.n(intro_module);
// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/car-reviews-v2.module.css
var car_reviews_v2_module = __webpack_require__(28131);
var car_reviews_v2_module_default = /*#__PURE__*/__webpack_require__.n(car_reviews_v2_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/intro/intro.tsx






const Intro = ({ contentTitle , contentStarRating , contentIntroText , authorImage , authorName , imageCount , introImage , latestPublishDate , video  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (car_reviews_v2_module_default()).inner,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (intro_module_default()).heading,
                children: contentTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRating, {
                starRating: Number(contentStarRating)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (car_reviews_v2_module_default()).reviewCopy,
                children: contentIntroText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Author, {
                name: authorName,
                image: authorImage,
                latestPublishDate: latestPublishDate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Media, {
                imageCount: imageCount,
                imageSrc: introImage.filename,
                alt: introImage.alt ?? "",
                video: video
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/intro/index.ts


// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(65358);
// EXTERNAL MODULE: ../../../node_modules/classnames/index.js
var classnames = __webpack_require__(95685);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/utils/capitalise-first-letter/capitalise-first-letter.ts
const capitaliseFirstLetter = (string)=>string.replace(/(^|\s|-)([a-z])/g, (_, leadingWhitespaceOrHyphen, lowercaseLetter)=>leadingWhitespaceOrHyphen + lowercaseLetter.toUpperCase());

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/utils/indefinite-article/indefinite-article.ts
const indefiniteArticle = (string)=>/^[aeiou]/i.test(string) ? "an" : "a";

// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/cta-button/cta-button.module.css
var cta_button_module = __webpack_require__(73206);
var cta_button_module_default = /*#__PURE__*/__webpack_require__.n(cta_button_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/cta-button/cta-button.tsx



const CtaButton = ({ href , onClick , small , className , children  })=>{
    const classNames = classnames_default()((cta_button_module_default()).ctaButton, {
        [`${className}`]: className,
        [(cta_button_module_default()).ctaButtonSmall]: small
    });
    if (href) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: href,
            onClick: onClick,
            className: classNames,
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        onClick: onClick,
        className: classNames,
        children: children
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/cta-button/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/search-button/search-button.tsx



const SearchButton = ({ make , model , small , className , onClick  })=>{
    const makeCapitalize = capitaliseFirstLetter(make);
    const modelCapitalize = capitaliseFirstLetter(model);
    const indefiniteArticleValue = indefiniteArticle(make);
    const formattedMake = make.toLowerCase().replace(/ /g, "-");
    const formattedModel = model.toLowerCase().replace(/ /g, "-");
    const searchButton = `Search for ${indefiniteArticleValue} ${makeCapitalize} ${modelCapitalize}`;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaButton, {
        href: `/used-cars/${formattedMake}/${formattedModel}`,
        onClick: onClick,
        className: className,
        small: small,
        children: searchButton
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/search-button/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/review-sections/review-sections.data.ts
const reviewSectionsData = [
    {
        id: "interior",
        title: "Interior"
    },
    {
        id: "performance",
        title: "Performance"
    },
    {
        id: "practicality",
        title: "Practicality"
    },
    {
        id: "running-costs",
        title: "Running costs"
    },
    {
        id: "verdict",
        title: "Verdict"
    }
];

// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/sticky-nav/sticky-nav.module.css
var sticky_nav_module = __webpack_require__(59783);
var sticky_nav_module_default = /*#__PURE__*/__webpack_require__.n(sticky_nav_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/sticky-nav/sticky-nav.tsx










const navRefs = reviewSectionsData.reduce((refs, item)=>{
    refs[item.id] = /*#__PURE__*/ react.createRef();
    return refs;
}, {});
const scrollIntoView = (element)=>{
    const navElement = element;
    const navContainer = document.querySelector(".stickyNavListScrollIntoView");
    if (navContainer) {
        const leftPosition = navElement.getBoundingClientRect().left + navContainer.scrollLeft;
        const containerCenter = navContainer.clientWidth / 2;
        const elementCenter = navElement.clientWidth / 2;
        // Calculate the scroll position for the center alignment
        const scrollPosition = leftPosition - containerCenter + elementCenter;
        // Smoothly scroll the container to the calculated position
        navContainer.scrollTo({
            left: scrollPosition,
            behavior: "smooth"
        });
    }
};
const StickyNav = ({ make , model , windowBottomScrollPosition , areVehiclesInStock  })=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const handleClick = (title)=>{
        trackEvent({
            eventName: `Car Review - Review Navigation Menu - ${title}`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: "review mega nav",
                    label: title,
                    action: make,
                    value: model
                }
            }
        });
    };
    const { vw  } = (0,util_src/* useViewport */.Sj)({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isDesktop = vw >= 1024;
    const verdictSection = modules/* scroller.get */.OK.get("verdict");
    const verdictSectionTopPosition = verdictSection === null || verdictSection === void 0 // optional chain required so tests pass
     ? void 0 : verdictSection.offsetTop;
    const showStickyWindowCtaButton = !isDesktop && windowBottomScrollPosition <= verdictSectionTopPosition;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: (sticky_nav_module_default()).stickyNav,
                "aria-hidden": true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((sticky_nav_module_default()).stickyNavInner, (car_reviews_v2_module_default()).inner),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: classnames_default()((sticky_nav_module_default()).stickyNavList, "stickyNavListScrollIntoView"),
                            children: reviewSectionsData.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    "aria-label": item.title,
                                    ref: navRefs[item.id],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                        className: (sticky_nav_module_default()).stickyNavLink,
                                        activeClass: (sticky_nav_module_default()).stickyNavLinkActive,
                                        to: item.id,
                                        spy: true,
                                        smooth: true,
                                        offset: -100,
                                        "data-text": item.title,
                                        onClick: ()=>handleClick(item.id),
                                        onSetActive: ()=>{
                                            const currentElement = navRefs[item.id].current;
                                            if (currentElement instanceof HTMLElement) {
                                                scrollIntoView(currentElement);
                                            }
                                        },
                                        children: item.title
                                    })
                                }, item.id))
                        }),
                        isDesktop && areVehiclesInStock && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton, {
                            make: make,
                            model: model,
                            small: true,
                            onClick: ()=>handleClick("search for vehicle")
                        })
                    ]
                })
            }),
            showStickyWindowCtaButton && areVehiclesInStock && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (sticky_nav_module_default()).stickyNavCtaMobileContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton, {
                    make: make,
                    model: model,
                    onClick: ()=>handleClick("search for vehicle"),
                    small: true
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/sticky-nav/index.ts


// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/review-sections/review-section.module.css
var review_section_module = __webpack_require__(33933);
var review_section_module_default = /*#__PURE__*/__webpack_require__.n(review_section_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/review-sections/review-sections.tsx











const scrollToTop = ()=>{
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
};
const ReviewSections = ({ make , model , reviewSections , children , imageCount , placeholderImage , areVehiclesInStock  })=>{
    const reviewSectionsRef = (0,react.useRef)(null);
    const [windowTopScrollPosition, setWindowTopScrollPosition] = (0,react.useState)(0);
    const [windowBottomScrollPosition, setWindowBottomScrollPosition] = (0,react.useState)(0);
    const isClient = !(0,util_src/* isSSR */.yF)();
    const handleScroll = ()=>{
        if (isClient) {
            const windowTopPosition = window.scrollY;
            const windowBottomPosition = window.scrollY + window.innerHeight;
            setWindowTopScrollPosition(windowTopPosition);
            setWindowBottomScrollPosition(windowBottomPosition);
        }
    };
    (0,react.useEffect)(()=>{
        if (isClient) {
            window.addEventListener("scroll", handleScroll, {
                passive: true
            });
            return ()=>{
                window.removeEventListener("scroll", handleScroll);
            };
        }
        return ()=>null;
    }, [
        handleScroll
    ]);
    let offsetPosition = 0;
    if (reviewSectionsRef.current) {
        const reviewSections1 = reviewSectionsRef.current.offsetTop;
        const negativeOffset = 54;
        offsetPosition = reviewSections1 - negativeOffset;
    }
    const showStickyNav = windowTopScrollPosition > offsetPosition;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: reviewSectionsRef,
        children: [
            isClient && showStickyNav && /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyNav, {
                make: make,
                model: model,
                windowBottomScrollPosition: windowBottomScrollPosition,
                areVehiclesInStock: areVehiclesInStock
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((car_reviews_v2_module_default()).inner, (car_reviews_v2_module_default()).sectionWrapper),
                children: [
                    reviewSections.map((section)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: (review_section_module_default()).carSectionWrapper,
                            id: section.title.toLocaleLowerCase().replace(" ", "-"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: (review_section_module_default()).title,
                                    children: section.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: (review_section_module_default()).sectionsRating,
                                    children: [
                                        "Our rating: ",
                                        section.rating,
                                        "/10"
                                    ]
                                }),
                                section.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Media, {
                                    imageCount: imageCount,
                                    imageSrc: section.image.filename ?? placeholderImage.filename,
                                    title: section.title,
                                    alt: section.image.alt ?? ""
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (review_section_module_default()).body,
                                    children: [
                                        (0,src/* renderWithResolver */.be)(section.body),
                                        section.quote ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Quote */.pu, {
                                            text: section.quote
                                        }) : null
                                    ]
                                })
                            ]
                        }, section.title.toLocaleLowerCase().replace(" ", "-"))),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (review_section_module_default()).chevronBackToTop,
                        onClick: scrollToTop,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.ChevronBackToTopIcon, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (review_section_module_default()).buttonBackToTop,
                                children: "Back to top"
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/review-sections/index.ts


// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/carousel/carousel.module.css
var carousel_module = __webpack_require__(13744);
var carousel_module_default = /*#__PURE__*/__webpack_require__.n(carousel_module);
// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/cards/cards.module.css
var cards_module = __webpack_require__(8107);
var cards_module_default = /*#__PURE__*/__webpack_require__.n(cards_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/cards/cards.tsx




const VehicleCard = ({ vehicle , carouselName  })=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const handleClick = ()=>{
        trackEvent({
            eventName: `Car Rewiew - PDP Cards Latest Vehicle ${vehicle.make} ${vehicle.model}`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: `car review ${carouselName === null || carouselName === void 0 ? void 0 : carouselName.replace("-", " ")}`,
                    label: vehicle.vehicleId,
                    action: "Open"
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (cards_module_default()).vehicleCardContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* VehicleCard */.Ur, {
            id: vehicle.vehicleId,
            isSaved: false,
            isPending: vehicle.isReserved,
            isAvailable: vehicle.isAvailable,
            vehicle: vehicle,
            isSmallCardSize: true,
            onCardClick: handleClick,
            isPersonalised: true
        }, vehicle.vehicleId)
    });
};
const VehicleCardsList = ({ vehicles , carouselName  })=>/*#__PURE__*/ _jsx("ul", {
        className: styles.vehicleCardList,
        "aria-label": carouselName,
        children: vehicles.map((vehicle)=>/*#__PURE__*/ _jsx("li", {
                children: /*#__PURE__*/ _jsx(VehicleCard, {
                    vehicle: vehicle,
                    carouselName: carouselName
                }, vehicle.vehicleId)
            }, vehicle.vehicleId))
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/carousel/carousel.tsx





const Carousel = ({ carouselName , vehicles  })=>{
    const navAriaLabels = {
        previous: "Go to previous slide",
        next: "Go to next slide"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Carousel */.lr, {
                name: carouselName,
                swiperSettings: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    breakpoints: {
                        564: {
                            slidesPerView: 1
                        },
                        768: {
                            slidesPerView: 2
                        },
                        1024: {
                            slidesPerView: 3
                        }
                    }
                },
                ariaLabel: `${carouselName}-carousel`,
                children: vehicles.map((vehicle)=>!vehicle.isReserved && vehicle.isAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselSlide */.qs, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleCard, {
                            vehicle: vehicle,
                            carouselName: "latest-cars"
                        })
                    }, vehicle.vehicleId))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* CarouselControls */.J8, {
                customClassNames: (carousel_module_default()).controlsWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselPagination */.Jj, {
                        name: carouselName,
                        className: classnames_default()(`${carouselName}-pagination`, (carousel_module_default()).pagination, (carousel_module_default()).customPagination),
                        "data-testid": "ds-carousel-pagination",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselNavigation */.Pn, {
                        name: carouselName,
                        ariaLabels: navAriaLabels,
                        ariaHidden: true,
                        customClassNames: {
                            prevButton: (carousel_module_default()).prevButton,
                            nextButton: (carousel_module_default()).nextButton
                        }
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/latest-cars/latest-cars.module.css
var latest_cars_module = __webpack_require__(14505);
var latest_cars_module_default = /*#__PURE__*/__webpack_require__.n(latest_cars_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/latest-cars/latest-cars.tsx







const LatestCars = ({ make , model  })=>{
    const { data , error  } = (0,src/* useLatestVehicles */.Kk)({
        make: make,
        model: model,
        count: 5,
        caller: "makesAndModels"
    });
    if (!data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (latest_cars_module_default()).carouselLoading,
            children: "Loading..."
        });
    }
    if (error) {
        console.log(error);
        return null;
    }
    if (data.vehicleListings.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (car_reviews_v2_module_default()).inner,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                className: (latest_cars_module_default()).title,
                children: [
                    "Latest ",
                    capitaliseFirstLetter(make),
                    " ",
                    model && capitaliseFirstLetter(model)
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                carouselName: "latest-cars",
                vehicles: data.vehicleListings
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/latest-cars/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/index.ts




// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/review-sections/verdict/verdict.module.css
var verdict_module = __webpack_require__(923);
var verdict_module_default = /*#__PURE__*/__webpack_require__.n(verdict_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/review-sections/verdict/verdict.tsx






const Verdict = ({ title , body , starRating , make , model , reviewSections , areVehiclesInStock  })=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const handleClick = ()=>{
        trackEvent({
            eventName: `Car Review - Search for a ${make} ${model}`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: "verdict",
                    label: "search for a vehicle",
                    action: make,
                    value: model
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (car_reviews_v2_module_default()).inner,
        id: "verdict",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (verdict_module_default()).verdictInner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (verdict_module_default()).heading,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (verdict_module_default()).title,
                                children: title || "The verdict"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(star_rating, {
                                starRating: starRating
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (verdict_module_default()).sectionVerdictWrapper,
                        children: reviewSections.map((section, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (verdict_module_default()).sectionVerdict,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (verdict_module_default()).verdictSectionsTitle,
                                        children: section.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (verdict_module_default()).verdictSectionsRating,
                                        children: [
                                            section.rating,
                                            "/10"
                                        ]
                                    })
                                ]
                            }, section.title))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (verdict_module_default()).content,
                        children: [
                            body,
                            " "
                        ]
                    })
                ]
            }),
            areVehiclesInStock && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton, {
                make: make,
                model: model,
                className: (verdict_module_default()).verdictSearchButton,
                onClick: ()=>handleClick()
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/review-sections/verdict/index.ts


// EXTERNAL MODULE: ../../../node_modules/react-focus-lock/dist/es2015/index.js + 30 modules
var es2015 = __webpack_require__(84097);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/modal/modal.tsx



function __Modal({ children , className , onOpen , onClose , ariaModal =true  }, ref) {
    const { isOpen , close , setReturnValue  } = useModal();
    const closeOnEscape = (e)=>{
        if (e.key === "Escape") close();
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("keydown", closeOnEscape);
        return ()=>{
            window.removeEventListener("keydown", closeOnEscape);
        };
    });
    (0,react.useEffect)(()=>{
        if (isOpen) {
            onOpen && onOpen();
        } else {
            onClose && onClose();
        }
    }, [
        isOpen
    ]);
    const onCloseFn = (e)=>{
        e.preventDefault();
        setReturnValue(e.currentTarget.returnValue);
        close();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("dialog", {
        open: isOpen,
        onClose: onCloseFn,
        ref: ref,
        className: className,
        "aria-modal": ariaModal,
        children: isOpen && children
    });
}
const Modal = /*#__PURE__*/ (0,react.forwardRef)(__Modal);

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/modal/index.ts



// EXTERNAL MODULE: ../../../node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(24624);
// EXTERNAL MODULE: ../../../node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(71535);
// EXTERNAL MODULE: ../../../node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(58479);
// EXTERNAL MODULE: ../../../node_modules/swiper/esm/components/navigation/navigation.js
var navigation = __webpack_require__(42167);
// EXTERNAL MODULE: ../../../node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(92949);
// EXTERNAL MODULE: ../../../node_modules/swiper/esm/components/a11y/a11y.js
var a11y = __webpack_require__(5438);
// EXTERNAL MODULE: ../../../node_modules/swiper/esm/components/keyboard/keyboard.js
var keyboard = __webpack_require__(60258);
// EXTERNAL MODULE: ../../../node_modules/swiper/esm/components/thumbs/thumbs.js
var thumbs = __webpack_require__(22067);
// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/car-review-gallery/car-review-gallery.module.css
var car_review_gallery_module = __webpack_require__(12131);
var car_review_gallery_module_default = /*#__PURE__*/__webpack_require__.n(car_review_gallery_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/car-review-gallery/car-review-gallery.tsx









core_class/* default.use */.Z.use([
    navigation/* default */.Z,
    pagination/* default */.Z,
    a11y/* default */.Z,
    keyboard/* default */.Z,
    thumbs/* default */.Z
]);
const CarReviewGallery = ({ images =[] , updateGalleryPaginationNumber , imageIndex  })=>{
    const [thumbsSwiper, setThumbsSwiper] = (0,react.useState)();
    const mainSwiper = (0,react.useRef)(null);
    const { vw  } = (0,util_src/* useViewport */.Sj)({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    (0,react.useEffect)(()=>{
        console.log({
            imageIndex
        });
    }, [
        imageIndex
    ]);
    const isDesktop = vw >= 1024;
    const slides = generateSlides(images, []);
    const thumbs = generateThumbs(images, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: classnames_default()((car_review_gallery_module_default()).btn, (car_review_gallery_module_default()).nextBtn),
                onClick: ()=>{
                    if (mainSwiper.current) {
                        mainSwiper.current.slideNext();
                    }
                },
                "aria-label": "Next slide",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.ChevronRightIcon, {
                    size: 24
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: classnames_default()((car_review_gallery_module_default()).btn, (car_review_gallery_module_default()).prevBtn),
                onClick: ()=>{
                    if (mainSwiper.current) {
                        mainSwiper.current.slidePrev();
                    }
                },
                "aria-label": "Previous slide",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.ChevronLeftIcon, {
                    size: 24
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                keyboard: true,
                loop: true,
                slidesPerView: 1,
                initialSlide: imageIndex || 0,
                className: (car_review_gallery_module_default()).featured,
                thumbs: {
                    swiper: thumbsSwiper,
                    slideThumbActiveClass: (car_review_gallery_module_default()).activeThumbnail
                },
                onSwiper: (swiper)=>mainSwiper.current = swiper,
                onSlideChange: (swiper)=>{
                    const slideChangeDetails = {
                        direction: swiper.touches.diff < 0 ? "right" : "left",
                        activeIndex: swiper.realIndex + 1
                    };
                    updateGalleryPaginationNumber(slideChangeDetails);
                },
                children: slides
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                onSwiper: (swiper)=>{
                    setThumbsSwiper(swiper);
                },
                className: (car_review_gallery_module_default()).thumbnails,
                slidesPerView: isDesktop ? 4.5 : 3.5,
                spaceBetween: 10,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                children: thumbs
            })
        ]
    });
};
function generateSlides(images, classNames) {
    return images.map((image, idx)=>{
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
            className: classnames_default()((car_review_gallery_module_default()).slide, ...classNames),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                className: image.title ? (car_review_gallery_module_default()).hasCaption : undefined,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,storyblok_src/* getStoryblokImageServiceUrl */.Vb)(image.filename, {
                            width: 800,
                            filters: [
                                {
                                    quality: 80
                                },
                                {
                                    fill: "transparent"
                                }
                            ],
                            fitIn: {
                                width: 800,
                                height: 600
                            }
                        }),
                        alt: (image === null || image === void 0 ? void 0 : image.alt) ?? "No Alt-Text provided."
                    }),
                    image.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                        className: (car_review_gallery_module_default()).slideFigcaption,
                        children: image.title
                    })
                ]
            })
        }, `${image.id}-${idx}`);
    });
}
function generateThumbs(images, classNames) {
    return images.map((image, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
            className: classnames_default()((car_review_gallery_module_default()).thumbnailSlide, ...classNames),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (0,storyblok_src/* getStoryblokImageServiceUrl */.Vb)(image.filename, {
                    filters: [
                        {
                            quality: 40
                        },
                        {
                            fill: "transparent"
                        }
                    ],
                    fitIn: {
                        width: 220,
                        height: 165
                    }
                }),
                alt: `Thumbnail for slide #${idx + 1}`
            })
        }, `${image.id}-${idx}-thumb`));
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/car-review-gallery/index.ts


// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/gallery-modal/gallery-modal.module.css
var gallery_modal_module = __webpack_require__(29134);
var gallery_modal_module_default = /*#__PURE__*/__webpack_require__.n(gallery_modal_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/gallery-modal/gallery-modal.tsx









function GalleryModal({ images =[]  }) {
    const { close , isOpen  } = useModal();
    const { imageIndex  } = useVehicleGallery();
    const prevFocusedElement = (0,react.useRef)(null);
    const closeButton = (0,react.useRef)(null);
    const [currentSlide, setCurrentSlide] = (0,react.useState)(0);
    const updateCurrentPagination = (details)=>{
        if (details.activeIndex !== undefined) {
            setCurrentSlide(details.activeIndex);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
        className: (gallery_modal_module_default()).galleryModal,
        onOpen: ()=>disableFocus(prevFocusedElement, closeButton),
        onClose: ()=>resetFocus(prevFocusedElement),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es2015/* default */.ZP, {
            disabled: !isOpen,
            className: (gallery_modal_module_default()).fullWidth,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (gallery_modal_module_default()).galleryModalInner,
                "aria-label": "image-gallery",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                        className: classnames_default()((gallery_modal_module_default()).galleryModalHeader, (gallery_modal_module_default()).uiColours),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    currentSlide,
                                    " / ",
                                    images.length
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: (gallery_modal_module_default()).galleryModalCloseButton,
                                    onClick: ()=>close(),
                                    "aria-label": "Close",
                                    ref: closeButton,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.CrossIcon, {
                                        size: 24
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CarReviewGallery, {
                        images: images,
                        updateGalleryPaginationNumber: updateCurrentPagination,
                        imageIndex: imageIndex
                    })
                ]
            })
        })
    });
}
function disableFocus(prevFocusedElementRef, closeButtonRef) {
    prevFocusedElementRef.current = document.activeElement;
    if (closeButtonRef.current) {
        closeButtonRef.current.focus();
        document.body.style.overflow = "hidden";
    }
}
function resetFocus(prevFocusedElementRef) {
    document.body.style.overflow = "unset";
    document.body.setAttribute("aria-hidden", "false");
    if (isHtmlElement(prevFocusedElementRef.current)) {
        prevFocusedElementRef.current.focus();
    }
}
function isHtmlElement(input) {
    return !!input && Object.prototype.hasOwnProperty.call(input, "focus");
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/gallery-modal/index.ts


// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/related-reviews/related-reviews.module.css
var related_reviews_module = __webpack_require__(77599);
var related_reviews_module_default = /*#__PURE__*/__webpack_require__.n(related_reviews_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/related-reviews/related-reviews.tsx






const formattedHref = (url)=>url.replace(/car-reviews-v2/g, "/used-cars");
const RelatedReviews = ({ items , make , model  })=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const handleClick = (currentMake, currentModel, suggestedVehicleReview)=>{
        const suggestedMakeAndModel = suggestedVehicleReview.replace(/\w+[!.?]?$/, "").toLocaleLowerCase();
        trackEvent({
            eventName: `similar reviews - from ${make} ${model}`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: "similar reviews",
                    label: `from ${currentMake} ${currentModel}`,
                    action: `to ${suggestedMakeAndModel}`
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (car_reviews_v2_module_default()).inner,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                element: "h2",
                fontSize: "h3",
                children: [
                    "Similar to the",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (related_reviews_module_default()).capitalise,
                        children: [
                            make,
                            " ",
                            model
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: " review"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (related_reviews_module_default()).relatedItem,
                        onClick: ()=>window.location.assign(formattedHref(item.full_slug)),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (related_reviews_module_default()).relatedImgWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (related_reviews_module_default()).relatedImgBorder,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (related_reviews_module_default()).relatedImg,
                                        alt: `${make} ${model}`,
                                        src: item.image || `${ false ? 0 : "https://landing-articles.snc-prod.aws.cinch.co.uk"}/image-coming-soon.svg`
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (related_reviews_module_default()).relatedContentWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                        element: "h3",
                                        className: (related_reviews_module_default()).relatedTitle,
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (related_reviews_module_default()).relatedStars,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRating, {
                                            starRating: Number(item.starRating)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (related_reviews_module_default()).relatedSnippet,
                                        children: item.snippet
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: formattedHref(item.full_slug),
                                        className: (related_reviews_module_default()).relatedLink,
                                        onClick: ()=>handleClick(make, model, item.title),
                                        children: "Read more"
                                    })
                                ]
                            })
                        ]
                    }, index))
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/related-reviews/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/cta-prefooter/cta-prefooter-data.ts
const ctaPreFooterData = {
    title: "Still not sure what you’re looking for?",
    body: "Need a little help deciding on your next motor? Get the inside scoop from our car fanatics"
};

// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/cta-prefooter/cta-prefooter.module.css
var cta_prefooter_module = __webpack_require__(46658);
var cta_prefooter_module_default = /*#__PURE__*/__webpack_require__.n(cta_prefooter_module);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-rum/esm/entries/main.js + 111 modules
var main = __webpack_require__(50163);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/cta-prefooter/cta-prefooter.tsx









const { Actions , Context  } = src/* Datadog */.og;
const CtaPreFooter = ()=>{
    const ctaButton = "View all car reviews";
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const handleClick = ()=>{
        trackEvent({
            eventName: `Car Review - ${ctaButton}`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: "view all car reviews",
                    label: "cta"
                }
            }
        });
        main/* datadogRum.addAction */.v.addAction(Actions.CLICK_CAR_REVIEW_CTA_PREFOOTER, {
            service: Context.CAR_REVIEW,
            squad: Context.SQUAD,
            page: window.location.pathname,
            value: "cta prefooter"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()((car_reviews_v2_module_default()).inner, (cta_prefooter_module_default()).ctaPreFooterContainer),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (cta_prefooter_module_default()).ctaPreFooterTextWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (cta_prefooter_module_default()).ctaPreFooterTitle,
                        children: ctaPreFooterData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (cta_prefooter_module_default()).ctaPreFooterDataBody,
                        children: [
                            ctaPreFooterData.body,
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaButton, {
                href: `/reviews`,
                className: (cta_prefooter_module_default()).ctaButton,
                onClick: ()=>handleClick(),
                children: ctaButton
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/pros-and-cons/pros-and-cons.module.css
var pros_and_cons_module = __webpack_require__(52986);
var pros_and_cons_module_default = /*#__PURE__*/__webpack_require__.n(pros_and_cons_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/pros-and-cons/create-pros-and-cons-array/create-pros-and-cons-array.ts
function createProsAndConsArray(prosList, consList) {
    const pros = {
        title: "Pros",
        body: prosList.map((item)=>item.text)
    };
    const cons = {
        title: "Cons",
        body: consList.map((item)=>item.text)
    };
    return [
        pros,
        cons
    ];
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/pros-and-cons/pros-and-cons.tsx








const ListItem = ({ text , isPro  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (pros_and_cons_module_default()).prosAndConsListItem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: isPro ? (pros_and_cons_module_default()).listItemIconPros : (pros_and_cons_module_default()).listItemIconCons,
                children: isPro ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TickWithCircle, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossIcon, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (pros_and_cons_module_default()).listItemText,
                children: text
            })
        ]
    });
const ProsAndCons = ({ prosList , consList , make , model , areVehiclesInStock  })=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const prosAndConsData = createProsAndConsArray(prosList, consList);
    const handleClick = ()=>{
        trackEvent({
            eventName: `Car Review - Search for a ${make} ${model}`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: "pros and cons",
                    label: "search for a vehicle",
                    action: make,
                    value: model
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (car_reviews_v2_module_default()).inner,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (pros_and_cons_module_default()).prosAndConsContainer,
                children: prosAndConsData.map((section, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (pros_and_cons_module_default()).prosAndConsSection,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (pros_and_cons_module_default()).prosAndConsTitle,
                                children: section.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: section.body.map((item, itemIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                        text: item,
                                        isPro: section.title === "Pros"
                                    }, itemIndex))
                            })
                        ]
                    }, index))
            }),
            areVehiclesInStock && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton, {
                make: make,
                model: model,
                onClick: ()=>handleClick()
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/helpers/helper.ts
const getGalleryImages = (gallery)=>gallery ? gallery.map((image)=>image.image) : [];
// add a placeholder image if there are no images in the gallery
const getFormattedGalleryImages = (galleryImages, placeholderImage)=>galleryImages.length === 0 ? [
        placeholderImage
    ] : galleryImages;
// get the default image for the section (ie. if no image is provided, use the placeholder image)
const getDefaultSectionImage = (section, placeholderImage)=>{
    var ref;
    return ((ref = section[0].image) === null || ref === void 0 ? void 0 : ref.filename) ? section[0].image : placeholderImage;
};

// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/error-modal/error-modal.module.css
var error_modal_module = __webpack_require__(15241);
var error_modal_module_default = /*#__PURE__*/__webpack_require__.n(error_modal_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/error-modal/error-modal.tsx


function ErrorModal({ validationErrors  }) {
    if (!validationErrors || !Array.isArray(validationErrors) || validationErrors.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (error_modal_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: (error_modal_module_default()).validationErrorTitle,
                    children: "Before publishing this review please address the errors"
                }),
                validationErrors.map((error, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (error_modal_module_default()).errorItem,
                        children: `${index + 1}. ${error}`
                    }, index))
            ]
        })
    });
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/components/error-modal/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/utils/remove-duplicates-images/remove-duplicates-images.ts

const removeDuplicatesKeepPlaceholders = (images)=>{
    const seenIds = new Set();
    return images.reduce((uniqueImages, image)=>{
        const isPlaceholder = image.filename === placeholderImage.filename;
        if (isPlaceholder || !image.id || !seenIds.has(image.id)) {
            if (image.id) seenIds.add(image.id);
            uniqueImages.push(image);
        }
        return uniqueImages;
    }, []);
};

// EXTERNAL MODULE: ../../../node_modules/next/script.js
var script = __webpack_require__(50430);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/car-reviews-v2.tsx
/* eslint-disable @typescript-eslint/ban-ts-comment */ 
















const placeholderImage = {
    alt: "Image coming soon",
    copyright: "cinch",
    filename: "https://a.storyblok.com/f/132543/400x253/4f1faa5d21/image-coming-soon.png",
    title: "Image coming soon",
    fieldtype: null,
    focus: null,
    name: "Image coming soon"
};
const JsonLdScript = ({ schema , tagId  })=>{
    const schemaToRender = Array.isArray(schema) ? schema[0] : schema;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        type: "application/ld+json",
        "data-testid": "json-ld-script",
        id: tagId,
        strategy: "beforeInteractive",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                "@context": "https://schema.org",
                ...schemaToRender
            }, null, 2)
        }
    });
};
function CarReviewsV2Feature({ story , generatedAt , preview , validationErrors , areVehiclesInStock  }) {
    var ref, ref1, ref2, ref3;
    const { content  } = (0,storyblok_src/* useStoryblokState */.f0)({
        story,
        enableBridge: preview
    });
    const IS_MOBILE_APP =  true && ((ref = window.navigator) === null || ref === void 0 ? void 0 : ref.userAgent.includes("cinchapp"));
    const { setImageIndexes  } = useVehicleGallery();
    const SEO = (content === null || content === void 0 ? void 0 : (ref1 = content.SEO) === null || ref1 === void 0 ? void 0 : ref1[0]) ?? {};
    const { make , model , verdict , starRating , introText , authorImage , authorName , title , interiorSection , performanceSection , practicalitySection , runningCostsSection , gallery , shouldShowLatestCars , relatedReviews , pros , cons , video  } = content;
    const sections = [
        interiorSection[0],
        performanceSection[0],
        practicalitySection[0],
        runningCostsSection[0]
    ];
    const prosList = pros[0].ProAndConList;
    const consList = cons[0].ProAndConList;
    const titles = reviewSectionsData.map((item)=>item.title);
    const reviewSections = sections.map((section, index)=>({
            ...section,
            title: titles[index]
        }));
    const contentStarRating = Number(starRating);
    const contentIntroText = (0,src/* renderWithResolver */.be)(introText);
    const verdictTitle = ((ref2 = verdict[0]) === null || ref2 === void 0 ? void 0 : ref2.title) || "";
    const verdictBody = (0,src/* renderWithResolver */.be)((ref3 = verdict[0]) === null || ref3 === void 0 ? void 0 : ref3.body);
    const galleryImages = getGalleryImages(gallery);
    const formattedGalleryImages = getFormattedGalleryImages(galleryImages, placeholderImage);
    const introImage = formattedGalleryImages === null || formattedGalleryImages === void 0 ? void 0 : formattedGalleryImages.at(0);
    const imagesWithDefaultSectionsImages = [
        ...formattedGalleryImages,
        ...sections.map((section)=>getDefaultSectionImage([
                section
            ], placeholderImage))
    ];
    const images = removeDuplicatesKeepPlaceholders(imagesWithDefaultSectionsImages);
    const imageCount = (images === null || images === void 0 ? void 0 : images.length) || 0;
    const formattedSections = {
        interior: interiorSection[0],
        performance: performanceSection[0],
        practicality: practicalitySection[0],
        runningCosts: runningCostsSection[0]
    };
    const latestPublishDate = story === null || story === void 0 ? void 0 : story.published_at;
    (0,react.useEffect)(()=>{
        setImageIndexes(images, formattedSections);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JsonLdScript, {
                schema: (0,src/* formatReviewToSchema */.VP)(content, `${latestPublishDate}`, {
                    pros: prosList,
                    cons: consList
                }),
                tagId: "review"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Head */.Fb, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: "Reviews - cinch",
                fallbackDescription: "We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: (car_reviews_v2_module_default()).page,
                children: [
                    gallery && /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryModal, {
                        images: images
                    }),
                    !IS_MOBILE_APP ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (car_reviews_v2_module_default()).breadcrumbSection,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (car_reviews_v2_module_default()).breadcrumbWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Breadcrumbs */.Oo, {
                                breadcrumbs: [
                                    {
                                        text: "Home",
                                        url: "/"
                                    },
                                    {
                                        text: "Reviews",
                                        url: "/reviews"
                                    },
                                    {
                                        text: title,
                                        url: ""
                                    }
                                ]
                            })
                        })
                    }) : null,
                    validationErrors && validationErrors.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorModal, {
                        validationErrors: validationErrors
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (car_reviews_v2_module_default()).sectionWrapper,
                        children: introImage && latestPublishDate && /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro, {
                            contentTitle: title,
                            contentStarRating: contentStarRating,
                            contentIntroText: contentIntroText,
                            authorName: authorName,
                            authorImage: authorImage,
                            imageCount: imageCount,
                            introImage: introImage,
                            latestPublishDate: latestPublishDate,
                            video: video
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (car_reviews_v2_module_default()).prosAndConsWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProsAndCons, {
                            prosList: prosList,
                            consList: consList,
                            make: make,
                            model: model,
                            areVehiclesInStock: areVehiclesInStock
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewSections, {
                        make: make,
                        model: model,
                        reviewSections: reviewSections,
                        imageCount: imageCount,
                        placeholderImage: placeholderImage,
                        areVehiclesInStock: areVehiclesInStock,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (car_reviews_v2_module_default()).verdictWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Verdict, {
                                title: verdictTitle,
                                body: verdictBody,
                                starRating: contentStarRating,
                                make: make,
                                model: model,
                                reviewSections: reviewSections,
                                areVehiclesInStock: areVehiclesInStock
                            })
                        })
                    }),
                    shouldShowLatestCars && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (car_reviews_v2_module_default()).sectionWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestCars, {
                            make: make,
                            model: model
                        })
                    }),
                    relatedReviews.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (car_reviews_v2_module_default()).sectionWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedReviews, {
                            make: make,
                            model: model,
                            items: relatedReviews
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (car_reviews_v2_module_default()).sectionWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaPreFooter, {})
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var car_reviews_v2 = ((/* unused pure expression or super */ null && (CarReviewsV2Feature)));

// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/utils/zod/car-review-v2-schemas.ts

const { array , string , object , number , boolean: car_review_v2_schemas_boolean , literal , union , lazy , any , tuple  } = lib.z;
const baseObjectSchema = object({
    _editable: string().optional(),
    _uid: string().uuid(),
    component: string()
});
// Created a util to pass thru a schema that we want or the placeholder we want to error on and give a custom error message that we can display to the content editors
const refinedSchemaPlaceholderUnion = (displayName, desiredSchema)=>union([
        desiredSchema,
        string()
    ]).refine((val)=>val !== "placeholder", {
        message: `${displayName}: Please replace placeholder value`
    });
const prosOrConsSchema = (displayName)=>baseObjectSchema.extend({
        ProAndConList: array(baseObjectSchema.extend({
            text: refinedSchemaPlaceholderUnion(`${displayName}`, string())
        })).min(1).max(3)
    });
const prosAndConsListSchema = (displayName)=>array(prosOrConsSchema(displayName));
const nullableString = union([
    string(),
    lib.z["null"]()
]);
const nullableNumber = lib.z.union([
    lib.z.number(),
    lib.z["null"]()
]);
const car_review_v2_schemas_imageSchema = lib.z.object({
    id: nullableNumber.optional(),
    alt: nullableString.optional(),
    name: nullableString.optional(),
    focus: nullableString.optional(),
    title: nullableString.optional(),
    filename: nullableString.optional(),
    copyright: nullableString.optional(),
    fieldtype: nullableString.optional()
});
const galleryImageSchema = baseObjectSchema.extend({
    image: car_review_v2_schemas_imageSchema
});
const galleryArrSchema = lib.z.array(galleryImageSchema).max(20).refine((images)=>images.some(({ image  })=>image.id || image.id === null), {
    message: "Gallery: must not contain the placeholder image."
});
const videoSchema = baseObjectSchema.extend({
    title: string(),
    videoId: string(),
    thumbnail: car_review_v2_schemas_imageSchema,
    buttonLabel: string()
}).passthrough();
const videoArrSchema = array(videoSchema).max(1);
const starRatingValidation = (displayName)=>lib.z.number({
        coerce: true
    }).refine((value)=>value !== 0, {
        message: `${displayName ? `${displayName}` : ""}: Rating cannot be 0`
    });
const richTextSchema = object({
    type: literal("doc"),
    content: array(any())
});
const verdictSchema = baseObjectSchema.extend({
    body: refinedSchemaPlaceholderUnion("Verdict", richTextSchema)
});
const verdictArrSchema = array(verdictSchema).max(1);
const sectionTextSchema = object({
    type: literal("doc"),
    content: array(any())
});
const sectionSchema = (displayName)=>baseObjectSchema.extend({
        body: refinedSchemaPlaceholderUnion(displayName, sectionTextSchema),
        image: car_review_v2_schemas_imageSchema,
        quote: string(),
        rating: starRatingValidation(displayName)
    });
const sectionArrSchema = (displayName)=>tuple([
        sectionSchema(displayName)
    ]);
const relatedReviewsSchema = lazy(()=>union([
        array(string()),
        array(contentSchema)
    ]));
const contentSchema = baseObjectSchema.extend({
    cons: prosAndConsListSchema("Cons"),
    make: string(),
    pros: prosAndConsListSchema("Pros"),
    model: string(),
    title: string(),
    video: videoArrSchema.optional(),
    gallery: galleryArrSchema,
    snippet: string().max(140),
    verdict: verdictArrSchema,
    introText: refinedSchemaPlaceholderUnion("Intro", sectionTextSchema),
    authorName: string(),
    starRating: starRatingValidation("Star Rating"),
    authorImage: car_review_v2_schemas_imageSchema,
    interiorSection: sectionArrSchema("Interior"),
    performanceSection: sectionArrSchema("Performance"),
    practicalitySection: sectionArrSchema("Practicality"),
    runningCostsSection: sectionArrSchema("Running Costs"),
    shouldShowLatestCars: car_review_v2_schemas_boolean()
});
// We've used passthrough here as well because there's a lot of data we don't care to validate
const car_review_v2_schemas_storySchema = object({
    name: string(),
    created_at: string().datetime(),
    published_at: string().datetime(),
    id: number(),
    uuid: string().uuid(),
    content: contentSchema,
    first_published_at: string().datetime()
}).passthrough();

// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var environments_src = __webpack_require__(48114);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/get-static-props.ts







const instrumentedGetStoryBySlug = (0,datadog_server_src/* traceFunction */.KG)("getStoryBySlug", storyblok_src/* getStoryBySlug */.OI);
const requiredParams = lib.z.object({
    make: lib.z.string(),
    model: lib.z.string(),
    slug: lib.z.string()
});
async function getStaticProps({ preview =false , params  }) {
    setTag("request.params", params);
    const ddMeta = {
        traceId: getTraceId(),
        traceTime: Date.now()
    };
    try {
        const { make , model , slug  } = requiredParams.parse(params);
        const isInsideStoryblok = preview;
        const storyArgs = {
            version: isInsideStoryblok ? "draft" : "published",
            resolve_relations: "CarReviewTemplateV2.relatedReviews",
            cv: Date.now()
        };
        const story = await instrumentedGetStoryBySlug(`car-reviews-v2/${make}/${model}/${slug}`, storyArgs);
        const parsedResults = storySchema.safeParse(story);
        let zodErrors = [];
        if (parsedResults.success === false) {
            zodErrors = zodErrorSerialiser(parsedResults.error);
        }
        const relatedReviews = [];
        if (story === null || story === void 0 ? void 0 : story.content.relatedReviews) {
            relatedReviews.push(...reduceRelatedReviews(story.content.relatedReviews));
        }
        const response = await fetch(`${readFromEnv(Env.SearchServiceUrl)}/vehicles?make=${story.content.make}&model=${story.content.model}`);
        if (!response.ok) {
            throw new Error(`Failed to fetch vehicles: ${response.statusText}`);
        }
        const { vehicleListings  } = await response.json();
        const vehiclesInStock = vehicleListings.some((vehicle)=>{
            var ref;
            return vehicle.make.toLowerCase() === story.content.make.toLowerCase() && ((ref = vehicle.model) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === story.content.model.toLowerCase();
        });
        setTag("response.statusCode", 200);
        return {
            props: {
                ddMeta,
                story: {
                    ...story,
                    content: {
                        ...story.content,
                        relatedReviews
                    }
                },
                preview,
                validationErrors: zodErrors,
                generatedAt: Date.now(),
                areVehiclesInStock: vehiclesInStock
            },
            revalidate: 30
        };
    } catch (error) {
        console.error(error);
        if (typeof error === "string" || error instanceof Error) {
            tagError(error);
        }
        if (error instanceof z.ZodError) {
            tagError(JSON.stringify(error.flatten().fieldErrors));
        }
        return {
            notFound: true,
            props: {
                ddMeta
            },
            revalidate: 30
        };
    }
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/lib/get-static-paths.ts


function createStaticPaths(links) {
    const paths = [];
    for (const link of Object.values(links)){
        // should look like /car-reviews-v2/ford/focus/2022
        const [, make, model, slug] = link.slug.split("/");
        // if it does not match, we don't want it
        if (make !== undefined && model !== undefined && slug !== undefined) {
            paths.push({
                params: {
                    make,
                    model,
                    slug
                }
            });
        }
    }
    return paths;
}
const getStaticPaths = async ()=>{
    // Get the paths we want to pre-render based on data
    try {
        const links = await getLinks("car-reviews-v2/");
        const paths = createStaticPaths(links);
        return {
            paths,
            fallback: "blocking"
        };
    } catch (error) {
        console.error(`Error fetching links for car-reviews-v2: ${error}`);
        if (error instanceof Error || typeof error === "string") {
            tagError(error);
        }
        return {
            paths: [],
            fallback: "blocking"
        };
    }
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-v2/src/index.ts




;// CONCATENATED MODULE: ./pages/used-cars/[make]/[model]/[slug]/index.tsx
var __N_SSG = true;



/***/ }),

/***/ 28131:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"car-reviews-v2_page__kYhtz","inner":"car-reviews-v2_inner__uhRSt","prosAndConsWrapper":"car-reviews-v2_prosAndConsWrapper__13rYU","reasonsToBuyWrapper":"car-reviews-v2_reasonsToBuyWrapper__zZ4Hg","sectionWrapper":"car-reviews-v2_sectionWrapper__vEHbh","breadcrumbSection":"car-reviews-v2_breadcrumbSection__JHDtW","breadcrumbWrapper":"car-reviews-v2_breadcrumbWrapper__c7YNF","verdictWrapper":"car-reviews-v2_verdictWrapper__SCPt9","reviewCopy":"car-reviews-v2_reviewCopy__vh2nV"};

/***/ }),

/***/ 19373:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"author_textContainer__uWS_A","breakline":"author_breakline__tHOH0","updatedOn":"author_updatedOn__vqORS","border":"author_border__Yim2C","author":"author_author__KvA_d"};

/***/ }),

/***/ 12131:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"swiperSlide":"car-review-gallery_swiperSlide__hzfem","swiperThumbnail":"car-review-gallery_swiperThumbnail__jYTQ_","slideFigcaption":"car-review-gallery_slideFigcaption__Vpk9H","thumbnails":"car-review-gallery_thumbnails__AR29h","featured":"car-review-gallery_featured__pBC74","slide":"car-review-gallery_slide__Mk6SG","hasCaption":"car-review-gallery_hasCaption__ByXdR","thumbnailSlide":"car-review-gallery_thumbnailSlide__h7Fq8","activeThumbnail":"car-review-gallery_activeThumbnail__8pAxJ","btn":"car-review-gallery_btn__oMpH3","nextBtn":"car-review-gallery_nextBtn__ebsDB","prevBtn":"car-review-gallery_prevBtn__j3lyB"};

/***/ }),

/***/ 8107:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"vehicleCardList":"cards_vehicleCardList__IDq1y","vehicleCardListItem":"cards_vehicleCardListItem__0xYaf","vehicleCardContainer":"cards_vehicleCardContainer__T8v6g","findSimilarVehiclesCard":"cards_findSimilarVehiclesCard__EkHU_","textContainer":"cards_textContainer__iDsg6","text":"cards_text__yq0Ws","button":"cards_button__TUa0f"};

/***/ }),

/***/ 13744:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"controlsWrapper":"carousel_controlsWrapper__IFEoo","pagination":"carousel_pagination__S_3e3","customPagination":"carousel_customPagination__wI6u6"};

/***/ }),

/***/ 73206:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ctaButton":"cta-button_ctaButton__AaqC8","ctaButtonSmall":"cta-button_ctaButtonSmall__g8ivR"};

/***/ }),

/***/ 46658:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ctaPreFooterContainer":"cta-prefooter_ctaPreFooterContainer__pYffG","ctaPreFooterTextWrapper":"cta-prefooter_ctaPreFooterTextWrapper__sx7Z4","ctaPreFooterTitle":"cta-prefooter_ctaPreFooterTitle__UwNV7","ctaPreFooterDataBody":"cta-prefooter_ctaPreFooterDataBody__I98ZA"};

/***/ }),

/***/ 15241:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"error-modal_wrapper__0NYQh","errorItem":"error-modal_errorItem__OOZSX","validationErrorTitle":"error-modal_validationErrorTitle___u3pG"};

/***/ }),

/***/ 29134:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"galleryModal":"gallery-modal_galleryModal__CvuJr","galleryModalInner":"gallery-modal_galleryModalInner__zY41b","galleryModalHeader":"gallery-modal_galleryModalHeader__30kOl","galleryModalCloseButton":"gallery-modal_galleryModalCloseButton__29doR","galleryModalGalleryContainer":"gallery-modal_galleryModalGalleryContainer__PsWzV","fullWidth":"gallery-modal_fullWidth__LxUAH"};

/***/ }),

/***/ 15145:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading":"intro_heading__ylXDk"};

/***/ }),

/***/ 14505:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carouselLoading":"latest-cars_carouselLoading__VTfji","cardContainer":"latest-cars_cardContainer__syuiW","title":"latest-cars_title__dCT9x"};

/***/ }),

/***/ 56303:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mediaContainer":"media_mediaContainer__emAC_","mediaImage":"media_mediaImage__AwJg0","mediaImageInfo":"media_mediaImageInfo__Tn7Tq","videoContainer":"media_videoContainer__Qta2_","video":"media_video__Y0Tyl"};

/***/ }),

/***/ 52986:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"prosAndConsContainer":"pros-and-cons_prosAndConsContainer__5u804","prosAndConsSection":"pros-and-cons_prosAndConsSection__exgTU","prosAndConsListItem":"pros-and-cons_prosAndConsListItem__LOhjk","prosAndConsTitle":"pros-and-cons_prosAndConsTitle__zRQyj","listItemText":"pros-and-cons_listItemText__17753","listItemIconPros":"pros-and-cons_listItemIconPros__inQVg","listItemIconCons":"pros-and-cons_listItemIconCons__lupp4"};

/***/ }),

/***/ 77599:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"capitalise":"related-reviews_capitalise__0ahDP","relatedItem":"related-reviews_relatedItem__gaJBn","relatedImgWrapper":"related-reviews_relatedImgWrapper__FnLmd","featured":"related-reviews_featured__WZugw","relatedImgBorder":"related-reviews_relatedImgBorder__R1fJ1","relatedImg":"related-reviews_relatedImg__959SM","relatedContentWrapper":"related-reviews_relatedContentWrapper__elbCC","relatedTitle":"related-reviews_relatedTitle__UkdWq","relatedStars":"related-reviews_relatedStars__ukS8r","relatedSnippet":"related-reviews_relatedSnippet__bUqU1","relatedLink":"related-reviews_relatedLink__NwbgR"};

/***/ }),

/***/ 33933:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sticky":"review-section_sticky__u97a0","title":"review-section_title__3fOxY","sectionsRating":"review-section_sectionsRating__mK2Cs","carSectionWrapper":"review-section_carSectionWrapper__0ZuHp","body":"review-section_body__FKBDD","chevronBackToTop":"review-section_chevronBackToTop__c_MHU","buttonBackToTop":"review-section_buttonBackToTop__pp6TY"};

/***/ }),

/***/ 923:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"verdictInner":"verdict_verdictInner__ekQ10","heading":"verdict_heading__Zvmxg","title":"verdict_title__j8mxj","sectionVerdictWrapper":"verdict_sectionVerdictWrapper__eE_CE","sectionVerdict":"verdict_sectionVerdict__l_i8o","verdictSectionsTitle":"verdict_verdictSectionsTitle__yjXdk","verdictSectionsRating":"verdict_verdictSectionsRating__xtH7N","verdictSearchButton":"verdict_verdictSearchButton__HnSf6","content":"verdict_content__BrALO"};

/***/ }),

/***/ 37590:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"starRatingContainer":"star-rating_starRatingContainer__yOQNy"};

/***/ }),

/***/ 59783:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stickyNav":"sticky-nav_stickyNav__9K5V6","stickyNavInner":"sticky-nav_stickyNavInner__Hlmli","stickyNavList":"sticky-nav_stickyNavList__4FpX8","stickyNavLink":"sticky-nav_stickyNavLink__38CPE","stickyNavLinkActive":"sticky-nav_stickyNavLinkActive__coze2","stickyNavCtaMobileContainer":"sticky-nav_stickyNavCtaMobileContainer__i0Ccn"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4249,9774,2888,179], function() { return __webpack_exec__(57947); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);